module.exports = "/_next/static/images/window_maximize_mac-e93534b2b9cdd27bf071c9a1ac61d22a.svg";